"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Upgrade/UpgradeModal/CombinedPlanModal/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _upgrade = require('shared/enum/upgrade');

var _cost = require('shared/services/cost');




var _upgradePlans = require('shared/constants/upgradePlans');
var _supportUrls = require('shared/data/supportUrls');







var _components = require('../components');







var _hooks = require('../hooks');









const zero = 0 

const CombinedPlanModal = ({
  orgName,
  orgKey,
  onClose,
  isSmsPreselected = false,
  analyticsContext,
}) => {
  const [isSmsSelected, setIsSmsSelected] = _react.useState.call(void 0, isSmsPreselected)
  const { isLoading, error, items, hasSubscription, savedCardData, discount } =
    _hooks.usePlan.call(void 0, { orgKey })
  const onCheckout = _hooks.useCheckout.call(void 0, {
    orgKey,
    hasSubscription,
    onEarlyCheckout: onClose,
    analyticsContext,
  })
  const {
    teamItem,
    phoneNumberItem,
    enabledSmsItem,
    smsItem,
    smsItemsList,
    smsItemMinCost,
    setSelectedSmsTier,
  } = _hooks.useRelevantItems.call(void 0, { items })

  const smsReceiptItem = isSmsSelected ? smsItem : enabledSmsItem
  const plansReceipt = _hooks.usePlansReceipt.call(void 0, {
    teamItem,
    phoneNumberItem,
    smsItem: smsReceiptItem,
    requestedItemType: _upgrade.SubscriptionItemType.TEAM,
  })

  const hasReceipt = !!savedCardData
  const { onPrev, onNext, isLoadingCheckout, currentStep } =
    _hooks.useCombinedCheckoutFlow.call(void 0, {
      onCheckout,
      hasReceipt,
      teamUnits: _optionalChain([teamItem, 'optionalAccess', _ => _.UnitsUsed]),
      smsUnits: _optionalChain([smsItem, 'optionalAccess', _2 => _2.Units]),
      isSmsSelected,
      analyticsContext,
    })

  if (error || isLoading) {
    return _react2.default.createElement(_components.PlanLoader, { isLoading: isLoading, error: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}} )
  }

  if (!teamItem) return null

  const teamUnitCost = teamItem.UnitCost || zero
  const totalCost = (
    teamUnitCost * teamItem.UnitsUsed
    + (isSmsSelected ? _optionalChain([smsItem, 'optionalAccess', _3 => _3.BaseCost]) || zero : zero)
  ) 
  const teamSeatPlanName = isSmsPreselected
    ? 'Base Messaging seats'
    : 'Team Chat seats'
  const previewConfig = isSmsPreselected
    ? {
        title: 'SMS Messaging',
        subtitle: 'Engage your patients, clients, and staff, directly from their phone.',
        baseCost: smsItemMinCost,
        pricePrefix: 'starting at',
        priceDesc: 'month',
        plan: _upgradePlans.SMSMessagingPlan,
        demoVideoUrl: _supportUrls.smsMessagingDemoVideoUrl,
      }
    : {
        title: 'Team Chat',
        subtitle: 'Chat with more than 10 members, and unlock powerful features.',
        baseCost: teamUnitCost,
        pricePrefix: undefined,
        priceDesc: 'user/month',
        plan: _upgradePlans.teamCommunicationPlan,
        demoVideoUrl: undefined,
      }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  currentStep === _hooks.UpgradeStep.PREVIEW && (
        _react2.default.createElement(_components.PlanPreview, {
          title: previewConfig.title,
          subtitle: previewConfig.subtitle,
          baseCost: previewConfig.baseCost,
          pricePrefix: previewConfig.pricePrefix,
          priceDesc: previewConfig.priceDesc,
          plan: previewConfig.plan,
          demoVideoUrl: previewConfig.demoVideoUrl,
          onContinue: onNext, __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}}
        )
      )
      ,  currentStep === _hooks.UpgradeStep.SUMMARY && (
        _react2.default.createElement(_components.PlanSummary, {
          title: "Review your plan"  ,
          subtitle: "Charges are based on the number of users in your organization and are adjusted automatically once a month."                 ,
          isNextLoading: isLoadingCheckout,
          isNextDisabled: isSmsSelected && !smsItem,
          onBack: onPrev,
          onNext: onNext, __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}

          , _react2.default.createElement(_components.PlanInfo, {
            orgName: orgName,
            planName: teamSeatPlanName,
            planIconSrc: _upgradePlans.baseMessagingPlan.iconSrc,
            desc: teamItem.UnitsUsed === 1 ? '1 user' : `${teamItem.UnitsUsed} users`,
            priceDesc: `${_cost.formatDisplayCost.call(void 0, teamUnitCost)} per user/month`,
            priceHint: "Base seats are required for coworkers in your organization. Secure team messaging is included."             ,
            billingFrequency: "billed monthly" ,
            totalPrice: teamUnitCost * teamItem.UnitsUsed , __self: this, __source: {fileName: _jsxFileName, lineNumber: 143}}
          )
          , _react2.default.createElement(_components.SmsAddonCard, {
            orgName: orgName,
            isSelected: isSmsSelected,
            onToggle: setIsSmsSelected,
            smsItem: smsItem,
            smsItemsList: smsItemsList,
            smsItemMinCost: smsItemMinCost,
            onTierChange: setSelectedSmsTier, __self: this, __source: {fileName: _jsxFileName, lineNumber: 153}}
          )
          , _react2.default.createElement('div', { className: "plan-modal--summary--total", __self: this, __source: {fileName: _jsxFileName, lineNumber: 162}}
            , _react2.default.createElement('span', { className: "plan-modal--summary--total--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}}, "Total per month"

            )
            , _react2.default.createElement('span', { className: "plan-modal--summary--total--price", __self: this, __source: {fileName: _jsxFileName, lineNumber: 166}}
              ,  _cost.formatDisplayCost.call(void 0, totalCost) 
            )
          )
        )
      )
      ,  currentStep === _hooks.UpgradeStep.BILLING && (
        _react2.default.createElement(_components.PlansReceipt, {
          discount: discount,
          savedCardData: savedCardData,
          planPreviews: plansReceipt,
          isNextLoading: isLoadingCheckout,
          onBack: onPrev,
          onNext: onNext, __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}}
        )
      )
    )
  )
}

exports. default = CombinedPlanModal
